const PREVIEW_STATUS_MESSAGES = {
  en: {
    "preview.queued": "Starting your preview...",
    "preview.background.removing": "Preparing your photo...",
    "preview.background.removed": "Photo prepared",
    "preview.background.cached": "Photo prepared",
    "preview.background.skipped": "Photo prepared",
    "preview.background.waiting": "Preparing your photo...",
    "preview.nn.enhancing": "Refining your portrait...",
    "preview.nn.enhanced": "Portrait refined",
    "preview.nn.cached": "Portrait refined",
    "preview.nn.waiting": "Refining your portrait...",
    "preview.slow": "Your preview is still taking shape...",
    "preview.rendering": "Creating your crystal preview...",
    "preview.uploading": "Finishing your preview...",
    "preview.ready": "Preview ready",
    "preview.failed": "Preview unavailable",
    "preview.cached": "Preview ready"
  },
  ko: {
    "preview.queued": "미리보기를 준비하고 있어요...",
    "preview.background.removing": "사진을 준비하고 있어요...",
    "preview.background.removed": "사진 준비 완료",
    "preview.background.cached": "사진 준비 완료",
    "preview.background.skipped": "사진 준비 완료",
    "preview.background.waiting": "사진을 준비하고 있어요...",
    "preview.nn.enhancing": "인물이 또렷하게 보이도록 다듬고 있어요...",
    "preview.nn.enhanced": "인물 보정 완료",
    "preview.nn.cached": "인물 보정 완료",
    "preview.nn.waiting": "인물이 또렷하게 보이도록 다듬고 있어요...",
    "preview.slow": "미리보기를 정성껏 만들고 있어요...",
    "preview.rendering": "크리스탈 미리보기를 만들고 있어요...",
    "preview.uploading": "미리보기를 마무리하고 있어요...",
    "preview.ready": "미리보기가 완성됐어요",
    "preview.failed": "미리보기를 확인할 수 없어요",
    "preview.cached": "미리보기가 완성됐어요"
  }
};

if (!customElements.get('product-preview-image')) {
  customElements.define(
    'product-preview-image',
    class ProductPreviewImage extends HTMLElement {
      static observedAttributes = ["data-sku"];

      onFileStackFileChoiceUnsubscriber = undefined;
      onEngraveTextChangedUnsubscribe = undefined;
      onEngraveFontChangedUnsubscribe = undefined;
      
      photoFileUrl = undefined;

      /**
       * @type {AbortController}
       */
      abortController = undefined;
      eventSource = undefined;

      activeBatchId = undefined;
      renderToken = 0;

      itemStatus = new Map();
      lastPreviewState = undefined;
      previewTotalEstimateMs = 20000;
      slowStatusDelayMs = 15000;

      mainGallery = undefined;
      thumbnailsGallery = undefined;

      swiperMainGallery = undefined;
      swiperThumbnailsGallery = undefined;

      source_font = 'Georgia';
      source_text = '';
      lightbox = undefined;
      

      constructor() {
        super();
        this.mainGallery = this.querySelector('.product-media-gallery');
        this.thumbnailsGallery = this.querySelector('.thumb-slider');

        this.source_font = document.querySelector('[name="properties[Font]"]')?.value || 'Georgia';
        this.source_text = document.querySelector('[name="properties[Engrave Text]"]')?.value || '';
      }

      initPhotoSwipe() {
        if (this.lightbox) {
          this.lightbox.destroy();
        }

        this.lightbox = new PhotoSwipeLightbox({
          gallery: this.querySelector('.product-media-gallery'),
          children: 'a',
          pswpModule: PhotoSwipe,
          clickToCloseNonZoomable: false,
          mouseMovePan: true,
          initialZoomLevel: 'fit',
          secondaryZoomLevel: 1.5,
          maxZoomLevel: 4,
        });
        this.lightbox.init();
      }

      connectedCallback() {
        this.onFileStackFileChoice = subscribe(
          PUB_SUB_EVENTS.filestackFileChoiced,
          this.onPhotoChanged.bind(this),
        );

        this.onEngraveTextChangedUnsubscribe = subscribe(
          PUB_SUB_EVENTS.engraveTextChanged,
          this.engraveTextChanged.bind(this)
        );

        this.onEngraveFontChangedUnsubscribe = subscribe(
          PUB_SUB_EVENTS.engraveFontChanged,
          this.engraveFontChanged.bind(this)
        );
        
        if (this.thumbnailsGallery) {
          this.swiperThumbnailsGallery = new Swiper(this.thumbnailsGallery.querySelector('.swiper'), {
            slidesPerView: "auto",
            watchSlidesProgress: true,
            direction: "horizontal",
            breakpoints: {
              769: {
                direction: "vertical",
              },
            }
          });
        }
        if (this.mainGallery) {
          this.swiperMainGallery = new Swiper(this.mainGallery, {
            slidesPerView: 1,
            effect: "fade",
            thumbs: this.swiperThumbnailsGallery ? {
              swiper: this.swiperThumbnailsGallery,
            } : {},
            navigation: {
              prevEl: this.thumbnailsGallery.querySelector('.button-prev'),
              nextEl: this.thumbnailsGallery.querySelector('.button-next'),
            }
          });
        }

        this.initPhotoSwipe()
      }

      disconnectedCallback() {
        this.onFileStackFileChoiceUnsubscriber?.();
        this.onEngraveTextChangedUnsubscribe?.();
        this.onEngraveFontChangedUnsubscribe?.();
        this.clearStatusState();
      }

      engraveFontChanged({ data: { value } }) {
        if (this.source_font != value) {
          this.source_font = value;
          this.processImageRender();
        }
      }

      /**
       * On change engrave text
       */
      engraveTextChanged({ data: { title, value } }) {
        if (this.source_text != value) {
          this.source_text = value;
          this.processImageRender();
        }
      }

      /**
       * On change photo
       *
       * @param url
       */
      onPhotoChanged({ data: { url } }) {
        this.photoFileUrl = url;
        this.processImageRender();
      }

      get form() {
        return document.querySelector('#'.concat(this.getAttribute('form')));
      }

      emitPreviewState(state, detail = {}) {
        this.lastPreviewState = state;
        this.dispatchEvent(new CustomEvent('ccm:preview-state', {
          bubbles: true,
          composed: true,
          detail: {
            formId: this.getAttribute('form'),
            state,
            ...detail,
          },
        }));
      }

      /**
       * Process change images or image
       */
      processImageRender() {
        if (this.productSku === '') return;
        if (!this.photoFileUrl) return;

        this.renderImage();
      }

      cancelBatch(batchId) {
        if (!batchId) {
          return;
        }
        fetch(this.baseUrl.concat(`/api/v2/previews/${batchId}/cancel`), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }).catch(() => {});
      }

      removePreviewSlides(swiperInstance) {
        const slides = swiperInstance.slides; // array-like of slide elements
        const indexesToRemove = [];

        // find indexes of slides with the class
        slides.forEach((slide, index) => {
          if (slide.classList.contains('preview-image-render')) {
            indexesToRemove.push(index);
          }
        });

        // Swiper expects indexes in descending order so it won’t shift
        indexesToRemove.sort((a, b) => b - a);

        indexesToRemove.forEach(i => swiperInstance.removeSlide(i));

        swiperInstance.update();

        return indexesToRemove;
      }
      
      removeSlideByElement(swiperInstance, element) {
        if (!element) {
          console.warn("Element not found.");
          return;
        }
        // 1. Find the index of the element
        const slides = swiperInstance.slides;
        let indexToRemove = -1;
   
        for (let i = 0; i < slides.length; i++) {
          if (slides[i] === element) {
            indexToRemove = i;
            break;
          }
        }
        
        if (indexToRemove !== -1) {
          // 2. Remove the slide using its index
          swiperInstance.removeSlide(indexToRemove);
          // 3. Update the Swiper instance
          // This is important to re-calculate slide positions and re-render
          swiperInstance.update();
        } else {
          console.warn("Element not found in Swiper slides.");
        }
      }

      renderImage() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.clearStatusState();
        const renderToken = ++this.renderToken;
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = undefined;
        }

        if (this.activeBatchId) {
          this.cancelBatch(this.activeBatchId);
          this.activeBatchId = undefined;
        }

        this.emitPreviewState('creating', { imageUrl: this.photoFileUrl });

        fetch(this.baseUrl.concat('/api/v2/previews'), {
          method: 'POST',
          signal: this.abortController.signal,
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            sku: this.productSku,
            source_image_url: this.optimizePhotoUrl(this.photoFileUrl),
            source_font: this.source_font,
            source_text: this.source_text,
          })
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Preview batch failed (${response.status})`);
            }
            return response.json();
          })
          .then((batch) => {
            if (renderToken !== this.renderToken) {
              return;
            }
            const items = Array.isArray(batch.items) ? batch.items : [];
            if (!items.length) {
              this.activeBatchId = undefined;
              this.emitPreviewState('error');
              return;
            }

            this.activeBatchId = batch.batch_id;
            this.previewTotalEstimateMs = Number.isFinite(batch.estimated_wait_ms)
              ? Math.max(5000, batch.estimated_wait_ms)
              : 20000;

            if (this.swiperMainGallery) {
              this.removePreviewSlides(this.swiperMainGallery)
            }
            if (this.swiperMainGallery) {
              this.removePreviewSlides(this.swiperThumbnailsGallery)
            }

            const slides = items.map((item, index) => `<div class="swiper-slide preview-image-render"><a href="${window.preloaderPreviewImage.src}" data-pswp-width="991" data-pswp-height="991"><img data-index="${index}" src="${window.preloaderPreviewImage.src}" width="750" height="750" alt="Loading"></a><div class="preview-status" data-index="${index}"><div class="preview-status__fill" style="width: 0%;"></div><div class="preview-status__content"><span class="preview-status__text">Queued</span><span class="preview-status__percent">0%</span></div><div class="preview-status__bar"><div class="preview-status__bar-fill" style="width: 0%;"></div></div></div></div>`);
            const thumbs = items.map((item, index) => `<div class="swiper-slide preview-image-render"><img data-index="${index}" src="${window.preloaderPreviewImage.src}" width="150" height="150" alt="Loading"></div>`);
            if (this.swiperMainGallery) {
              this.swiperMainGallery.prependSlide(slides);
              this.swiperMainGallery.slideTo(0)
            }
            if (this.swiperThumbnailsGallery) {
              this.swiperThumbnailsGallery.prependSlide(thumbs);
              this.swiperThumbnailsGallery.slideTo(0)
            }

            const itemIndex = new Map();
            items.forEach((item, index) => {
              if (item.item_id) {
                itemIndex.set(item.item_id, index);
              }
              if (item.status === 'cached' && item.result_url) {
                const mediumUrl = item.medium_url || item.mediumUrl || item.medium;
                this.applyRenderedImage(
                  index,
                  item.result_url,
                  item.thumbnail_url || mediumUrl || item.result_url,
                  mediumUrl || item.result_url
                );
              }
            });

            this.initializeItemStatus(items, itemIndex);
            this.attachEventSource(batch.batch_id, itemIndex, items.length, renderToken);
          })
          .catch((error) => {
            if (renderToken !== this.renderToken) {
              return;
            }
            console.warn(error);
            this.setAllItemsStatus({
              message_key: "preview.failed",
              stage: "failed",
              progress_min: 0,
              progress_max: 0,
              done: true,
            });
            this.activeBatchId = undefined;
            this.emitPreviewState('error');
          });
      }

      initializeItemStatus(items, itemIndex) {
        this.clearStatusState();
        items.forEach((item) => {
          if (!item.item_id || !itemIndex.has(item.item_id)) {
            return;
          }
          const index = itemIndex.get(item.item_id);
          this.itemStatus.set(item.item_id, {
            index,
            progress: 0,
            stage: 'queued',
            completed: false,
            timerId: undefined,
            slowTimerId: undefined,
          });
          this.setItemStatus(item.item_id, {
            message_key: "preview.queued",
            stage: "queued",
            progress_min: 0,
            progress_max: 0,
          });
          if (item.status === 'cached') {
            this.setItemStatus(item.item_id, {
              message_key: "preview.cached",
              stage: "completed",
              progress_min: 100,
              progress_max: 100,
              done: true,
            });
          }
        });
      }

      attachEventSource(batchId, itemIndex, totalItems, renderToken) {
        if (!window.EventSource) {
          this.pollBatch(batchId, itemIndex, totalItems, renderToken);
          return;
        }
        let completedCount = 0;
        this.eventSource = new EventSource(this.baseUrl.concat(`/api/v2/previews/${batchId}/events`));
        const handleEvent = (event) => {
          if (renderToken !== this.renderToken) {
            return;
          }
          const data = JSON.parse(event.data || '{}');
          if (data.batch_id && data.batch_id !== batchId) {
            return;
          }
          if (!data.item_id) {
            this.setAllItemsStatus(data);
            return;
          }
          if (!itemIndex.has(data.item_id)) {
            return;
          }
          const index = itemIndex.get(data.item_id);
          this.setItemStatus(data.item_id, data);
          if (data.result_url) {
            const mediumUrl = data.medium_url || data.mediumUrl || data.medium;
            this.applyRenderedImage(
              index,
              data.result_url,
              data.thumbnail_url || mediumUrl || data.result_url,
              mediumUrl || data.result_url
            );
          }
          if (data.type === 'item.completed' || data.type === 'item.cached' || data.type === 'item.failed') {
            completedCount += 1;
            if (completedCount >= totalItems) {
              this.eventSource?.close();
              this.activeBatchId = undefined;
            }
          }
        };
        [
          'background.started',
          'background.completed',
          'background.cached',
          'background.skipped',
          'background.waiting',
          'nn.started',
          'nn.completed',
          'nn.cached',
          'nn.waiting',
          'item.started',
          'item.uploading',
          'item.completed',
          'item.cached',
          'item.failed'
        ].forEach((eventName) => {
          this.eventSource.addEventListener(eventName, handleEvent);
        });
        this.eventSource.onerror = () => {
          this.eventSource?.close();
          this.pollBatch(batchId, itemIndex, totalItems, renderToken);
        };
      }

      pollBatch(batchId, itemIndex, totalItems, renderToken) {
        const startedAt = Date.now();
        this.setAllItemsStatus({
          message_key: "preview.rendering",
          stage: "rendering",
          progress_min: 52,
          progress_max: 90,
        });
        const pollOnce = () => {
          if (renderToken !== this.renderToken) {
            return;
          }
          if (Date.now() - startedAt > 45000) {
            console.warn("Timeout 45s for generate image");
            this.activeBatchId = undefined;
            this.setAllItemsStatus({
              message_key: "preview.failed",
              stage: "failed",
              progress_min: 0,
              progress_max: 0,
              done: true,
            });
            return;
          }
          fetch(this.baseUrl.concat(`/api/v2/previews/${batchId}`), {
            signal: this.abortController.signal,
            cache: "no-store"
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Preview status failed (${response.status})`);
              }
              return response.json();
            })
            .then((batch) => {
              const items = Array.isArray(batch.items) ? batch.items : [];
              let completedCount = 0;
              items.forEach((item) => {
                if (item.status === 'completed' || item.status === 'cached') {
                  completedCount += 1;
                  const index = itemIndex.get(item.item_id);
                  if (index !== undefined && item.result_url) {
                    const mediumUrl = item.medium_url || item.mediumUrl || item.medium;
                    this.applyRenderedImage(
                      index,
                      item.result_url,
                      item.thumbnail_url || mediumUrl || item.result_url,
                      mediumUrl || item.result_url
                    );
                  }
                  this.setItemStatus(item.item_id, {
                    message_key: item.status === 'cached' ? "preview.cached" : "preview.ready",
                    stage: "completed",
                    progress_min: 100,
                    progress_max: 100,
                    done: true,
                  });
                } else if (item.status === 'failed') {
                  completedCount += 1;
                  this.setItemStatus(item.item_id, {
                    message_key: "preview.failed",
                    stage: "failed",
                    progress_min: 0,
                    progress_max: 0,
                    done: true,
                  });
                }
              });
              if (completedCount < totalItems) {
                setTimeout(pollOnce, 5000);
                return;
              }
              this.activeBatchId = undefined;
            })
            .catch((error) => {
              if (renderToken !== this.renderToken) {
                return;
              }
              console.warn(error);
              this.setAllItemsStatus({
                message_key: "preview.failed",
                stage: "failed",
                progress_min: 0,
                progress_max: 0,
                done: true,
              });
              this.activeBatchId = undefined;
            });
        };
        pollOnce();
      }

      applyRenderedImage(index, fullUrl, thumbUrl, mediumUrl) {
        if (this.swiperMainGallery) {
          const img = this.mainGallery.querySelector(`[data-index="${index}"]`);
          const link = img?.parentNode;
          const savedMediumUrl = img?.dataset.mediumUrl;
          const displayUrl = mediumUrl || savedMediumUrl || fullUrl;
          const zoomUrl = fullUrl || mediumUrl || savedMediumUrl;
          if (img && displayUrl) {
            if (mediumUrl) {
              img.dataset.mediumUrl = mediumUrl;
            }
            img.removeAttribute('srcset');
            img.setAttribute('src', displayUrl);
          }
          if (link) {
            if (zoomUrl || displayUrl) {
              link.setAttribute('href', zoomUrl || displayUrl);
            }
            if (zoomUrl || displayUrl) {
              link.setAttribute('data-pswp-src', zoomUrl || displayUrl);
            }
          }
        }
        if (this.swiperThumbnailsGallery) {
          const displayUrl = mediumUrl || fullUrl;
          this.thumbnailsGallery.querySelector(`[data-index="${index}"]`)?.setAttribute('src', thumbUrl || displayUrl);
        }
        if (this.form) {
          const formPreviewUrl = fullUrl || mediumUrl;
          const fallbackThumbUrl = thumbUrl || formPreviewUrl;
          const preview = this.form.querySelector('[name="properties[_preview_image_url]"]');
          const preview_thumb = this.form.querySelector('[name="properties[_preview_image_thumbnail_url]"]');
          if (preview) {
            preview.value = formPreviewUrl;
          } else {
            const preview_input = document.createElement('input');
            preview_input.type = 'hidden';
            preview_input.value = formPreviewUrl;
            preview_input.name = 'properties[_preview_image_url]';
            this.form.append(preview_input);
          }
          if (preview_thumb) {
            preview_thumb.value = fallbackThumbUrl;
          } else {
            const preview_thumb_input = document.createElement('input');
            preview_thumb_input.type = 'hidden';
            preview_thumb_input.value = fallbackThumbUrl;
            preview_thumb_input.name = 'properties[_preview_image_thumbnail_url]';
            this.form.append(preview_thumb_input);
          }
        }
        this.emitPreviewState('ready', {
          imageUrl: mediumUrl || fullUrl,
          thumbnailUrl: thumbUrl || mediumUrl || fullUrl,
        });
      }

      setAllItemsStatus(data) {
        this.itemStatus.forEach((state, itemId) => {
          if (state.completed) {
            return;
          }
          this.setItemStatus(itemId, data);
        });
      }

      setItemStatus(itemId, data) {
        if (!itemId || !this.itemStatus.has(itemId)) {
          return;
        }
        const state = this.itemStatus.get(itemId);
        const defaults = this.getEventDefaults(data.type);
        const messageKey = data.message_key || data.messageKey || defaults.message_key;
        const fallbackMessage = data.message || data.status || '';
        const message = this.getStatusMessage(messageKey, fallbackMessage);
        const progressMin = Number.isFinite(data.progress_min)
          ? data.progress_min
          : (Number.isFinite(data.progressMin) ? data.progressMin : defaults.progress_min);
        const progressMax = Number.isFinite(data.progress_max)
          ? data.progress_max
          : (Number.isFinite(data.progressMax) ? data.progressMax : defaults.progress_max);
        const stage = data.stage || defaults.stage;
        const stageOrder = this.getStageOrder(stage);
        const currentOrder = this.getStageOrder(state.stage);
        const isDone = data.done || stage === 'completed' || data.type === 'item.completed' || data.type === 'item.cached';
        const isFailed = data.type === 'item.failed' || stage === 'failed';

        if (!isDone && !isFailed && stageOrder < currentOrder) {
          return;
        }

        this.updateStatusOverlay(state.index, message, state.progress);
        this.startProgressTimer(itemId, progressMin, progressMax, isDone, isFailed);
        this.startSlowTimer(itemId, isDone, isFailed);

        if (isDone || isFailed) {
          state.completed = true;
          state.stage = stage || state.stage;
          if (state.slowTimerId) {
            clearTimeout(state.slowTimerId);
            state.slowTimerId = undefined;
          }
          if (isFailed) {
            this.emitPreviewState('error');
          }
          return;
        }
        if (stage) {
          state.stage = stage;
        }
      }

      startProgressTimer(itemId, progressMin, progressMax, isDone, isFailed) {
        const state = this.itemStatus.get(itemId);
        if (!state) {
          return;
        }
        if (state.timerId) {
          clearInterval(state.timerId);
          state.timerId = undefined;
        }

        if (!Number.isFinite(progressMin) || !Number.isFinite(progressMax)) {
          return;
        }

        const clampedMin = Math.max(0, Math.min(100, progressMin));
        const clampedMax = Math.max(0, Math.min(100, progressMax));
        let nextProgress = Math.max(state.progress || 0, clampedMin);

        if (clampedMax <= clampedMin || isDone || isFailed) {
          const finalValue = isFailed ? clampedMin : clampedMax;
          state.progress = finalValue;
          this.updateStatusOverlay(state.index, undefined, finalValue, isDone || isFailed);
          return;
        }

        const range = clampedMax - clampedMin;
        const durationMs = Math.max(1500, Math.round(this.previewTotalEstimateMs * (range / 100)));
        const tickMs = 200;
        const step = range / Math.max(1, Math.round(durationMs / tickMs));

        state.progress = nextProgress;
        this.updateStatusOverlay(state.index, undefined, nextProgress);
        state.timerId = setInterval(() => {
          nextProgress = Math.min(clampedMax, nextProgress + step);
          state.progress = nextProgress;
          this.updateStatusOverlay(state.index, undefined, nextProgress);
          if (nextProgress >= clampedMax) {
            clearInterval(state.timerId);
            state.timerId = undefined;
          }
        }, tickMs);
      }

      startSlowTimer(itemId, isDone, isFailed) {
        const state = this.itemStatus.get(itemId);
        if (!state || isDone || isFailed) {
          return;
        }
        if (state.slowTimerId) {
          clearTimeout(state.slowTimerId);
        }
        state.slowTimerId = setTimeout(() => {
          if (!state.completed) {
            this.emitPreviewState('slow', { imageUrl: this.photoFileUrl });
            this.updateStatusOverlay(
              state.index,
              this.getStatusMessage("preview.slow", "This is taking longer than usual..."),
              state.progress
            );
          }
        }, this.slowStatusDelayMs);
      }

      updateStatusOverlay(index, message, progress, isDone) {
        const overlay = this.ensureStatusOverlay(index);
        if (!overlay) {
          return;
        }
        const textEl = overlay.querySelector('.preview-status__text');
        const percentEl = overlay.querySelector('.preview-status__percent');
        const barFill = overlay.querySelector('.preview-status__bar-fill');
        const pillFill = overlay.querySelector('.preview-status__fill');
        if (message && textEl) {
          textEl.textContent = message;
        }
        if (Number.isFinite(progress)) {
          const value = Math.round(progress);
          if (percentEl) {
            percentEl.textContent = `${value}%`;
          }
          if (barFill) {
            barFill.style.width = `${value}%`;
          }
          if (pillFill) {
            pillFill.style.width = `${value}%`;
          }
        }
        if (isDone) {
          if (!overlay.dataset.doneAt) {
            overlay.dataset.doneAt = String(Date.now());
            setTimeout(() => {
              overlay.classList.add('preview-status--done');
            }, 1200);
          }
        }
      }

      ensureStatusOverlay(index) {
        if (!this.mainGallery) {
          return undefined;
        }
        return this.mainGallery.querySelector(`.preview-status[data-index="${index}"]`);
      }

      clearStatusState() {
        this.itemStatus.forEach((state) => {
          if (state.timerId) {
            clearInterval(state.timerId);
          }
          if (state.slowTimerId) {
            clearTimeout(state.slowTimerId);
          }
        });
        this.itemStatus.clear();
      }

      getStatusMessage(messageKey, fallbackMessage) {
        const locale = this.getLocale();
        if (messageKey && PREVIEW_STATUS_MESSAGES[locale]?.[messageKey]) {
          return PREVIEW_STATUS_MESSAGES[locale][messageKey];
        }
        if (messageKey && PREVIEW_STATUS_MESSAGES.en?.[messageKey]) {
          return PREVIEW_STATUS_MESSAGES.en[messageKey];
        }
        return fallbackMessage;
      }

      getEventDefaults(eventType) {
        const defaults = {
          message_key: undefined,
          stage: undefined,
          progress_min: undefined,
          progress_max: undefined,
        };
        switch (eventType) {
          case 'background.started':
            return { message_key: "preview.background.removing", stage: "background", progress_min: 1, progress_max: 18 };
          case 'background.completed':
            return { message_key: "preview.background.removed", stage: "background", progress_min: 18, progress_max: 18 };
          case 'background.cached':
            return { message_key: "preview.background.cached", stage: "background", progress_min: 18, progress_max: 18 };
          case 'background.skipped':
            return { message_key: "preview.background.skipped", stage: "background", progress_min: 18, progress_max: 18 };
          case 'background.waiting':
            return { message_key: "preview.background.waiting", stage: "background", progress_min: 1, progress_max: 18 };
          case 'nn.started':
            return { message_key: "preview.nn.enhancing", stage: "nn", progress_min: 19, progress_max: 51 };
          case 'nn.completed':
            return { message_key: "preview.nn.enhanced", stage: "nn", progress_min: 51, progress_max: 51 };
          case 'nn.cached':
            return { message_key: "preview.nn.cached", stage: "nn", progress_min: 51, progress_max: 51 };
          case 'nn.waiting':
            return { message_key: "preview.nn.waiting", stage: "nn", progress_min: 19, progress_max: 51 };
          case 'item.started':
            return { message_key: "preview.rendering", stage: "rendering", progress_min: 52, progress_max: 90 };
          case 'item.uploading':
            return { message_key: "preview.uploading", stage: "uploading", progress_min: 91, progress_max: 99 };
          case 'item.completed':
            return { message_key: "preview.ready", stage: "completed", progress_min: 100, progress_max: 100 };
          case 'item.cached':
            return { message_key: "preview.cached", stage: "completed", progress_min: 100, progress_max: 100 };
          case 'item.failed':
            return { message_key: "preview.failed", stage: "failed", progress_min: 0, progress_max: 0 };
          default:
            return defaults;
        }
      }

      getStageOrder(stage) {
        switch (stage) {
          case 'queued':
            return 0;
          case 'background':
            return 1;
          case 'nn':
            return 2;
          case 'rendering':
            return 3;
          case 'uploading':
            return 4;
          case 'completed':
            return 5;
          case 'failed':
            return 6;
          default:
            return 0;
        }
      }

      getLocale() {
        const lang = document.documentElement?.lang || 'en';
        if (lang.toLowerCase().startsWith('ko')) {
          return 'ko';
        }
        return 'en';
      }

      /**
       * Optimize image link
       *
       * @param url
       * @returns {string}
       */
      optimizePhotoUrl(url) {
        let image_url_object = new URL(url);
        if (image_url_object.hostname !== 'filestackcontent.com' && !image_url_object.hostname.endsWith('.filestackcontent.com')) return url;
        let image_name = image_url_object.pathname.replace('/', '');
        return 'https://cdn.filestackcontent.com/' + window.legacyPhotoTransformKey + '/resize=h:600,f:max/output=f:jpg/' +
          image_name;
      }

      /**
       * On changed attribute (look: observedAttributes)
       *
       * @param name
       * @param oldValue
       * @param newValue
       */
      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'data-sku') {
          this.processImageRender()
        }
        console.log(
          `Attribute ${name} has changed from ${oldValue} to ${newValue}.`,
        );
      }

      /**
       * Base url address
       *
       * @returns {string}
       */
      get baseUrl() {
        return window.routes?.apps_crystal_settings || '/apps/crystal-settings';
      }

      /**
       * Get product sku for image processor
       *
       * @returns {string}
       */
      get productSku() {
        if (this.dataset.sku.length === 15 || this.dataset.sku.length === 16) {
          return this.dataset.sku;
        }
        let sku = this.dataset.sku
          .replace('-CUSTOM', '')
          .replace('-CUSTM', '');
        if (sku.includes("-")) {
          return sku.concat("-CUSTM").slice(0, 16)
        }
        return sku.concat("-A-CUSTM").slice(0, 16);
      }

    }
  );
}
